/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateInterpretationNormDto
 */
export interface CreateUpdateInterpretationNormDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInterpretationNormDto
     */
    normid?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateInterpretationNormDto
     */
    rangeFrom?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateInterpretationNormDto
     */
    rangeTo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateInterpretationNormDto
     */
    variation?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInterpretationNormDto
     */
    result?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateInterpretationNormDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateInterpretationNormDto interface.
 */
export function instanceOfCreateUpdateInterpretationNormDto(value: object): value is CreateUpdateInterpretationNormDto {
    return true;
}

export function CreateUpdateInterpretationNormDtoFromJSON(json: any): CreateUpdateInterpretationNormDto {
    return CreateUpdateInterpretationNormDtoFromJSONTyped(json, false);
}

export function CreateUpdateInterpretationNormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateInterpretationNormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'normid': json['normid'] == null ? undefined : json['normid'],
        'rangeFrom': json['rangeFrom'] == null ? undefined : json['rangeFrom'],
        'rangeTo': json['rangeTo'] == null ? undefined : json['rangeTo'],
        'variation': json['variation'] == null ? undefined : json['variation'],
        'result': json['result'] == null ? undefined : json['result'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateUpdateInterpretationNormDtoToJSON(value?: CreateUpdateInterpretationNormDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'normid': value['normid'],
        'rangeFrom': value['rangeFrom'],
        'rangeTo': value['rangeTo'],
        'variation': value['variation'],
        'result': value['result'],
        'description': value['description'],
    };
}

